import React from 'react';
import { KpiCard } from '../components/ui/KpiCard';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { AlertCircle, Info } from 'lucide-react';
const lineData = Array.from({
  length: 30
}, (_, i) => ({
  day: i + 1,
  verificados: Math.floor(Math.random() * 30) + 10,
  cualificados: Math.floor(Math.random() * 5)
}));
const barData = [{
  name: 'GMB',
  value: 400
}, {
  name: 'IG',
  value: 300
}, {
  name: 'FB',
  value: 150
}, {
  name: 'Directorio',
  value: 100
}, {
  name: 'Referral',
  value: 50
}];
const territories = [{
  name: 'MAD-Centro',
  leads: 245,
  conv: '4.2%'
}, {
  name: 'BCN-Eixample',
  leads: 190,
  conv: '3.8%'
}, {
  name: 'VAL-Ruzafa',
  leads: 120,
  conv: '5.1%'
}, {
  name: 'SEV-Centro',
  leads: 85,
  conv: '2.9%'
}];
export function Dashboard() {
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-653">
      <div className="flex items-center justify-between" data-id="element-654">
        <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-655">
          Dashboard Operativo
        </h1>
        <div className="text-[13px] text-growthly-muted" data-id="element-656">Mayo 2026</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-657">
        <KpiCard title="Leads Verificados" value={452} target={800} progress={452 / 800 * 100} delta={12} deltaType="positive" data-id="element-658" />
        <KpiCard title="Ciclo Activo" value={128} delta={-5} deltaType="negative" data-id="element-659" />
        <KpiCard title="Micro-acuerdos" value={42} delta={8} deltaType="positive" data-id="element-660" />
        <KpiCard title="Leads Cualificados" value={14} target={35} progress={14 / 35 * 100} delta={2} deltaType="positive" data-id="element-661" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-662">
        <div className="lg:col-span-2 space-y-6" data-id="element-663">
          <div className="card p-5" data-id="element-664">
            <h3 className="text-[14px] font-medium text-growthly-muted mb-4" data-id="element-665">
              Evolución 30 días
            </h3>
            <div className="h-[250px] w-full" data-id="element-666">
              <ResponsiveContainer width="100%" height="100%" data-id="element-667">
                <LineChart data={lineData} margin={{
                top: 5,
                right: 20,
                bottom: 5,
                left: -20
              }} data-id="element-668">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,0.06)" data-id="element-669" />
                  <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#BDBDBD'
                }} data-id="element-670" />
                  <YAxis axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#BDBDBD'
                }} data-id="element-671" />
                  <Tooltip contentStyle={{
                  backgroundColor: '#1F1F1F',
                  borderRadius: '8px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#FFFFFF'
                }} itemStyle={{
                  color: '#FFFFFF'
                }} data-id="element-672" />
                  <Legend iconType="circle" wrapperStyle={{
                  fontSize: '12px',
                  color: '#E6E6E6'
                }} data-id="element-673" />
                  <Line type="monotone" dataKey="verificados" name="Verificados" stroke="#FFFFFF" strokeWidth={2} dot={false} data-id="element-674" />
                  <Line type="monotone" dataKey="cualificados" name="Cualificados" stroke="#27AE60" strokeWidth={2} dot={false} data-id="element-675" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-676">
            <div className="card p-5" data-id="element-677">
              <h3 className="text-[14px] font-medium text-growthly-muted mb-4" data-id="element-678">
                Canales de Origen
              </h3>
              <div className="h-[200px] w-full" data-id="element-679">
                <ResponsiveContainer width="100%" height="100%" data-id="element-680">
                  <BarChart data={barData} layout="vertical" margin={{
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 20
                }} data-id="element-681">
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="rgba(255,255,255,0.06)" data-id="element-682" />
                    <XAxis type="number" hide data-id="element-683" />
                    <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                    fontSize: 12,
                    fill: '#BDBDBD'
                  }} data-id="element-684" />
                    <Tooltip cursor={{
                    fill: 'rgba(255,255,255,0.05)'
                  }} contentStyle={{
                    backgroundColor: '#1F1F1F',
                    borderRadius: '8px',
                    border: '1px solid rgba(255,255,255,0.1)'
                  }} data-id="element-685" />
                    <Bar dataKey="value" fill="#FFFFFF" radius={[0, 4, 4, 0]} barSize={20} data-id="element-686" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="card p-5" data-id="element-687">
              <h3 className="text-[14px] font-medium text-growthly-muted mb-4" data-id="element-688">
                Top Territorios
              </h3>
              <div className="overflow-x-auto" data-id="element-689">
                <table className="w-full text-[13px] text-left" data-id="element-690">
                  <thead className="text-[12px] text-growthly-muted border-b border-white/5" data-id="element-691">
                    <tr data-id="element-692">
                      <th className="pb-2 font-medium" data-id="element-693">Territorio</th>
                      <th className="pb-2 font-medium text-right" data-id="element-694">Leads</th>
                      <th className="pb-2 font-medium text-right" data-id="element-695">Conv.</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white/5" data-id="element-696">
                    {territories.map((t, i) => <tr key={i} className="hover:bg-white/[0.02] transition-colors" data-id="element-697">
                        <td className="py-2.5 font-medium text-growthly-text" data-id="element-698">
                          {t.name}
                        </td>
                        <td className="py-2.5 text-right text-growthly-muted" data-id="element-699">
                          {t.leads}
                        </td>
                        <td className="py-2.5 text-right font-medium text-growthly-green" data-id="element-700">
                          {t.conv}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4" data-id="element-701">
          <h3 className="text-[14px] font-medium text-growthly-muted" data-id="element-702">
            Alertas Activas
          </h3>

          <div className="bg-growthly-red/5 border border-growthly-red/30 rounded-lg p-4 shadow-sm flex items-start space-x-3" data-id="element-703">
            <AlertCircle className="w-5 h-5 text-growthly-red flex-shrink-0 mt-0.5" data-id="element-704" />
            <div data-id="element-705">
              <h4 className="text-[14px] font-semibold text-growthly-red" data-id="element-706">
                Plan de Choque Activo
              </h4>
              <p className="text-[12px] text-growthly-red/80 mt-1" data-id="element-707">
                Acumulado &le; 30% del objetivo. Incremento de intentos +20%
                requerido por 7 días.
              </p>
              <button className="mt-3 text-[12px] font-medium text-growthly-bg bg-growthly-red px-3 py-1.5 rounded hover:bg-growthly-red/90 transition-colors" data-id="element-708">
                Ver tareas
              </button>
            </div>
          </div>

          <div className="bg-growthly-surface border border-white/10 rounded-lg p-4 shadow-sm flex items-start space-x-3" data-id="element-709">
            <Info className="w-5 h-5 text-growthly-muted flex-shrink-0 mt-0.5" data-id="element-710" />
            <div data-id="element-711">
              <h4 className="text-[14px] font-semibold text-growthly-text" data-id="element-712">
                QA Score Bajo
              </h4>
              <p className="text-[12px] text-growthly-muted mt-1" data-id="element-713">
                Tu media semanal es 13/20. Tienes un 1:1 programado para mañana.
              </p>
            </div>
          </div>

          <div className="bg-growthly-surface border border-white/10 rounded-lg p-4 shadow-sm flex items-start space-x-3" data-id="element-714">
            <div className="w-2 h-2 rounded-full bg-growthly-green mt-1.5 flex-shrink-0" data-id="element-715"></div>
            <div data-id="element-716">
              <h4 className="text-[14px] font-medium text-growthly-text" data-id="element-717">
                SLA Enriquecimiento OK
              </h4>
              <p className="text-[12px] text-growthly-muted mt-1" data-id="element-718">
                0 leads pendientes de enriquecimiento inicial.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}